import React from "react";
import { FourColumnRowSectionProps } from "types/staff-detail.types";

const DEFAULT_LABEL_WIDTH = 220;

const FourColumnRowSection: React.FC<FourColumnRowSectionProps> = ({
  leftTitle,
  rightTitle,
  rows,
  labelWidth = DEFAULT_LABEL_WIDTH,
}) => {
  const hasRightColumn = rows.some((row) => row.rightLabel || row.rightValue);
  const labelStyle = { width: `${labelWidth}px` };

  return (
    <div className="bg-white rounded-2xl px-6 py-3 last:pb-0">
      <div
        className={`hidden xl:grid bg-gray-100 rounded-xl h-[48px] items-center px-3 font-medium text-[15px] uppercase ${
          hasRightColumn ? "grid-cols-[auto_1fr_auto_1fr]" : "grid-cols-[auto_1fr]"
        }`}
      >
        <div className="w-60">{leftTitle}</div>
        <div />
        {hasRightColumn && <div style={labelStyle}>{rightTitle}</div>}
        {hasRightColumn && <div />}
      </div>

      {/* Rows */}
      <div className="flex flex-col">
        {rows.map((row, index) => (
          <div
            key={index}
            className={`grid grid-cols-1 xl:grid-cols-[auto_1fr_auto_1fr] items-start xl:items-center px-3 py-4 xl:py-0 min-h-[48px] border-b gap-y-2 xl:gap-x-6`}
          >
            {/* Cột trái - Label */}
            <div 
              className="text-[14px] text-[var(--textBlack80Rgba)] xl:font-medium xl:w-[220px]" 
              style={window.innerWidth > 1024 ? labelStyle : {}}
            >
              {row.leftLabel}
            </div>
            {/* Cột trái - Value */}
            <div className="text-[14px] w-full mb-3 xl:mb-0">
              {row.leftValue}
            </div>

            {/* Cột phải*/}
            {hasRightColumn && (
              <>
                {/* Cột phải - Label */}
                <div 
                  className="text-[14px] text-[var(--textBlack80Rgba)] xl:font-medium xl:w-[220px] border-t xl:border-t-0 pt-3 xl:pt-0" 
                  style={window.innerWidth > 1024 ? labelStyle : {}}
                >
                  {row.rightLabel}
                </div>
                {/* Cột phải - Value */}
                <div className="text-[14px] w-full flex items-center gap-3">
                  {row.rightValue}
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FourColumnRowSection;